export default "__VITE_ASSET__C5mR5bvt__"